import { generatePath, Link as RouterLink } from "react-router-dom";

import { Link, Theme, Typography } from "@mui/material";
import { SxProps } from "@mui/system";

import truncate from "lodash/truncate";

import { HistoryLogDto as HistoryLogModel } from "../../interfaces/HistoryLogDto";
import { dateToStringLong } from "../../common/utils/dateTime";
import SectionPreview from "../../common/components/SectionPreview";

const style = (theme: Theme): SxProps => {
  return {
    textDecoration: "none",
    pr: 1,
    "&:hover": {
      color: theme.palette.secondary.dark,
      textDecoration: "underline",
    },
  };
};

type HistoryLogProps = {
  logs?: Array<HistoryLogModel>;
  path: string;
};

export default function HistoryLog({ logs, path }: HistoryLogProps) {
  const render = () => {
    return (
      <SectionPreview title="Предишни версии на документа">
        {logs?.map((log) => (
          <Typography key={log.historyId}>
            <Link
              target="_blank"
              component={RouterLink}
              to={generatePath(path, { id: log.historyId.toString() })}
              color="secondary.main"
              sx={(theme) => ({ ...style(theme) })}
            >
              {dateToStringLong(log.createDate)}
            </Link>
            {truncate(log.correctionReason ?? "", { length: 90 })}
          </Typography>
        ))}
      </SectionPreview>
    );
  };

  return logs ? render() : null;
}
